import { IPublishTerm } from '../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { EServiceId } from '../../../types/reducers/publishTerms';
import { getServiceId } from '../../../utils/publishTerms';
import { getPeriodId } from './getPeriodId';

export function getSelectedPeriodId(terms: IPublishTerm[], serviceId: EServiceId | null): number | null {
  const term = terms.find(term => serviceId === getServiceId(term.services));

  if (!term || !term.periods) {
    return null;
  }

  const { periods } = term;

  const paidPeriod = periods.find(({ isPaid }) => isPaid);
  const defaultPeriod = periods.find(({ isDefault }) => isDefault);
  const firstPeriod = periods[0];

  if (paidPeriod) {
    return getPeriodId(paidPeriod);
  }

  if (defaultPeriod) {
    return getPeriodId(defaultPeriod);
  }

  if (firstPeriod) {
    return getPeriodId(firstPeriod);
  }

  return null;
}
